import i18n from '../../../../../locales/index'
import customBreadCrumb from './custom-bread-crumb.vue'
export default customBreadCrumb
